import React from 'react';
import Popup from 'reactjs-popup';
import CustomFieldValueFields from '../../CustomFieldValues/components/CustomFieldValueFields';
import { groupByTicket } from '../hooks/useCustomFields';

// Mirrors the RefundModal's contentStyle so the two modals on this page match.
const modalContentStyle = {
  backgroundColor: 'var(--sl-bg-primary)',
  textAlign: 'left',
  border: 'none',
  borderRadius: '8px',
  boxShadow: '0 0 1px 1px rgba(0,0,0,0.02), 0 4px 6px 1px rgba(0,0,0,0.06)',
  width: '560px',
  maxWidth: '95vw',
  padding: '0px',
};

const CustomFieldsModal = ({
  open, onClose, values, onChange, onSubmit, canSave, submitting,
  team, confirm, csrfToken, defaultCountry,
}) => (
  <Popup open={open} onClose={onClose} modal closeOnDocumentClick={!submitting} contentStyle={modalContentStyle} className="popup-modal">
    <div>
      <div className="op-cf-modal-header">
        <h2 className="op-cf-modal-title">Edit Custom Fields</h2>
        <a
          href="#"
          className="op-cf-modal-close"
          aria-label="Close"
          onClick={(e) => { e.preventDefault(); onClose(); }}
        >
          <i className="fal fa-times"></i>
        </a>
      </div>
      <div className="op-cf-modal-body">
        <CustomFieldValueFields
          team={team}
          csrfToken={csrfToken}
          confirm={confirm}
          customFieldValues={values.filter((cfv) => !cfv.ticketId)}
          customFieldValueChanged={onChange}
          wrapPhoneInRow
          defaultCountry={defaultCountry}
        />
        {groupByTicket(values).map((group) => (
          <div key={group.ticketId} data-testid={`ticket-answer-fields-${group.ticketId}`}>
            <h3 className="op-cf-modal-ticket">{group.label}</h3>
            <CustomFieldValueFields
              team={team}
              csrfToken={csrfToken}
              confirm={confirm}
              customFieldValues={group.values}
              customFieldValueChanged={onChange}
              wrapPhoneInRow
              defaultCountry={defaultCountry}
              idSuffix={`ticket-${group.ticketId}`}
            />
          </div>
        ))}
      </div>
      <div className="op-cf-modal-footer">
        <button type="button" className="op-btn" onClick={onClose} disabled={submitting}>Cancel</button>
        <button type="button" className="op-btn op-btn-primary" disabled={!canSave || submitting} onClick={onSubmit}>
          {submitting ? 'Saving…' : 'Save'}
        </button>
      </div>
    </div>
  </Popup>
);

export default CustomFieldsModal;
